import { render, staticRenderFns } from "./personalCategoryPicker.vue?vue&type=template&id=1a4e764e&scoped=true"
import script from "./personalCategoryPicker.vue?vue&type=script&lang=js"
export * from "./personalCategoryPicker.vue?vue&type=script&lang=js"
import style0 from "./personalCategoryPicker.vue?vue&type=style&index=0&id=1a4e764e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4e764e",
  null
  
)

export default component.exports